angular.module('admin.reports').controller('RevenuesReportCtrl',
    function (ReportsResource, dateRangePickerConfig, $http, config) {

        this.config = config;
        this.datePickerOpts = angular.extend(angular.copy(dateRangePickerConfig), {
            eventHandlers: {
                'apply.daterangepicker': () => {
                    this.loadReport();
                }
            }
        });

        this.initializeFilter = function () {
            this.filter = { period: {}, newSubs: true, oldSubs: true, monthly: true, yearly: true, query: '' };

            this.filter.period = {
                startDate: moment().subtract(30, 'day'),
                endDate: moment().endOf('day')
            };

            this.pagination = {
                currentPage: 1,
                pageSize: 50
            };


            this.futureFilter = {
                query: ''
            };

            this.futurePagination = {
                currentPage: 1,
                pageSize: 50
            };

        }


        this.loadReport = function () {

            var request = {
                startDate: this.filter.period.startDate.format('YYYY-MM-DD'),
                endDate: this.filter.period.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')
            };




            ReportsResource.revenueReport(request, (data) => {
                this.reportData = data;

                this.filterReport();

            }, (err) => {

            });
        }


        this.filterReport = function (page) {

            if (page)
                this.pagination.currentPage = page;

            var upperCaseQuery = this.filter.query.toUpperCase();
            this.filteredData = this.reportData.filter((x) => {
                if (this.filter.newSubs != this.filter.oldSubs)
                    if (this.filter.newSubs && !x.isNew)
                        return false;
                    else if (this.filter.oldSubs && x.isNew)
                        return false;

                if (this.filter.monthly != this.filter.yearly)
                    if (this.filter.monthly && x.intervalCount != 1)
                        return false;
                    else if (this.filter.yearly && x.intervalCount != 12)
                        return false;


                if (upperCaseQuery) {
                    if (this.filter.query == x.subscriptionNumber)
                        return true;
                    else if (x.customerName.toUpperCase().indexOf(upperCaseQuery) >= 0)
                        return true;
                    else
                        return false;
                }

                return true;
            });

            this.updateTotals();

            this.pagination.totalItems = this.filteredData.length;

            var skip = (this.pagination.currentPage - 1) * this.pagination.pageSize;
            if (skip > this.pagination.totalItems)
                skip = 0;

            var paginated = this.filteredData.slice(skip, skip + this.pagination.pageSize);
            this.filteredData = paginated;

        }

        this.updateTotals = function () {
            var total = 0, totalNew = 0;

            this.filteredData.forEach((rev) => {
                if (rev.isNew)
                    totalNew += rev.amount;
                total += rev.amount;
            });

            this.totals = {
                quantity: this.filteredData.length,
                allSubscriptions: total,
                newSubscriptions: totalNew,
                oldSubscriptions: total - totalNew
            };
        }


        this.loadFutureRevenues = function () {
            if (!this.futureRevenues)
                ReportsResource.futureRevenues((data) => {
                    this.futureRevenues = data;
                    this.filterFuture();
                });
        }

        this.loadMissingRevenues = function () {
            if (!this.missingRevenues)
                ReportsResource.missingRevenues((data) => {
                    this.missingRevenues = data;
                });
        }



        this.filterFuture = function (page) {

            if (page)
                this.futurePagination.currentPage = page;

            var filtered = this.futureRevenues;

            if (this.futureFilter.query) {
                var upperQuery = this.futureFilter.query.toUpperCase();
                filtered = filtered.filter((x) => {
                    if (x.subscriptionNumber == upperQuery) {
                        return true;
                    }

                    if (x.customerName.toUpperCase().indexOf(upperQuery) >= 0)
                        return true;

                    return false;
                });
            }

            this.futurePagination.totalItems = filtered.length;

            var skip = (this.futurePagination.currentPage - 1) * this.futurePagination.pageSize;
            this.filteredFuture = filtered.slice(skip, skip + this.futurePagination.pageSize);

        }


        this.loadChart = function () {
            ReportsResource.revenueChart((data) => {
                this.reportChart = {
                    chart: {
                        type: 'column',
                    },
                    colors: ['#5cb1e6', '#ff9900'],
                    title: {
                        text: 'Receitas Mês a Mês'
                    },
                    xAxis: {
                        categories: data.categories
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: 'Total financeiro'
                        },
                        stackLabels: {
                            enabled: true,
                            style: {
                                fontWeight: 'bold',
                                color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
                            }
                        }
                    },
                    legend: {
                        align: 'right',
                        x: -30,
                        verticalAlign: 'top',
                        y: 25,
                        floating: true,
                        backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
                        borderColor: '#CCC',
                        borderWidth: 1,
                        shadow: false
                    }, plotOptions: {
                        column: {
                            stacking: 'normal',
                            dataLabels: {
                                enabled: true,
                                color: 'black' || (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
                            }
                        }, series: {
                            cursor: 'pointer'
                        }

                    },
                    series: data.series,

                };

                data.series.forEach((s) => {
                    s.events = {
                        click: (e) => {
                            this.setFilterBySeries(e.point);

                        }
                    };
                })

            }, (err) => {

            });
        };

        this.setFilterBySeries = function (point) {
            var category = point.category;

            var months = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

            var parts = category.split('/');
            var month = months.indexOf(parts[0]);
            var year = parseInt(parts[1]);

            var date = new Date(year, month, 1, 0, 0, 0, 0);

            var period = {
                startDate: moment(date),
                endDate: moment(date).endOf('month')
            };
            this.filter.period = period;
            this.loadReport();

        }

        this.exportToExcel = function () {


            var request = {
                startDate: this.filter.period.startDate.format('YYYY-MM-DD'),
                endDate: this.filter.period.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
                newSubs: this.filter.newSubs,
                oldSubs: this.filter.oldSubs,
                monthly: this.filter.monthly,
                yearly: this.filter.yearly
            };


            $http({
                url: config.api + '/api/AdminRevenueReport/GetExcel',
                params: request,
                method: 'GET',
                responseType: 'arraybuffer'
            }).then((res) => {

                var filename = `ReceitasCanalEnergia_${request.startDate}_${request.endDate.substring(0, 10)}.xlsx`;

                res.headers();
                var url = URL.createObjectURL(new Blob([res.data], { type: 'arraybuffer' }));
                var a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.target = '_blank';
                a.click();
            });
        }

        this.exportFutureToExcel = function () {

            $http({
                url: config.api + '/api/AdminRevenueReport/GetFutureExcel',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then((res) => {

                var filename = `AssinaturasAgendadas.xlsx`;

                res.headers();
                var url = URL.createObjectURL(new Blob([res.data], { type: 'arraybuffer' }));
                var a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.target = '_blank';
                a.click();
            });
        }

        this.initializeFilter();
        this.loadReport();
        this.loadChart();

    });